import React from 'react';
import { useTranslation } from '../../i18n/i18n';
import { CalendarOffIcon } from '../icons/Icons';
import './EmptyPeriod.scss';

/** Stands in for a detail page's data when the chosen period holds no readings. */
const EmptyPeriod = () => {
  const { t } = useTranslation('common');
  return (
    <section aria-label={t('period.empty.label')} className="EmptyPeriod">
      <CalendarOffIcon stroke="var(--color-text-2)" />
      <h2>{t('period.empty.title')}</h2>
      <p>{t('period.empty.text')}</p>
    </section>
  );
};

export default EmptyPeriod;
